import { Stat as InnerStat, StatHelpText, StatNumber } from './stat';
import { StatLabel } from './styles';
const Stat = InnerStat;
Stat.HelpText = StatHelpText;
Stat.Label = StatLabel;
Stat.Number = StatNumber;
export default Stat;
